<template lang="html">

</template>

<script>
export default {
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/Company/Dashboard/Social/Instagram.vue